const API = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = 'nextxus-managed-speech';
export const SPEECH_MODELS = ['tts-1', 'tts-1-hd'];
export const SPEECH_VOICES = ['alloy', 'ash', 'coral', 'echo', 'fable', 'nova', 'onyx', 'sage', 'shimmer'];

export function readSpeechSettings() {
  let saved = {};
  try { saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; } catch { /* storage unavailable */ }
  return {
    model: SPEECH_MODELS.includes(saved.model) ? saved.model : 'tts-1',
    voice: SPEECH_VOICES.includes(saved.voice) ? saved.voice : 'nova',
    speed: Number.isFinite(saved.speed) && saved.speed >= 0.25 && saved.speed <= 4 ? saved.speed : 1,
  };
}

export function saveSpeechSettings(settings) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(settings)); } catch { /* session-only settings */ }
}

export async function requestSpeech(text, settings, signal) {
  if (!API) throw new Error('The speech service address is not configured.');
  const response = await fetch(`${API}/api/speech/generate`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text, ...settings }), signal,
  });
  const data = await response.json();
  if (!response.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Use 1–4,096 characters and valid voice settings.');
  return { ...data, audio_url: `${API}${data.audio_url}` };
}